/* ============================================================
   FootyFits Flag Builder — supporter/wall flags.
   Recolourable club patterns + national flags (drawn to canvas),
   a movable-layers system (add any number of text lines + crests/images,
   each dragged freely), exported at 3500px and attached to the order.
   ============================================================ */
(function(){
  function $(id){ return document.getElementById("fb-" + id); }
  var root = $("root"); if(!root) return;

  var DATA = { sizes: [] };
  try{ DATA = JSON.parse($("data").textContent); }catch(e){ DATA = { sizes: [] }; }
  if(!DATA.sizes || !DATA.sizes.length) return;

  var FONTS = [
    { id:"anton",  name:"Anton",       css:'"Anton"' },
    { id:"bebas",  name:"Bebas",       css:'"Bebas Neue"' },
    { id:"oswald", name:"Oswald",      css:'"Oswald"' },
    { id:"staat",  name:"Staatliches", css:'"Staatliches"' },
    { id:"archivo",name:"Archivo",     css:'"Archivo"' }
  ];
  var PATTERNS = [
    { id:"solid",    name:"Solid" },
    { id:"halvesV",  name:"Halves (vertical)" },
    { id:"halvesH",  name:"Bands (horizontal)" },
    { id:"stripesV", name:"Stripes (vertical)" },
    { id:"stripesH", name:"Stripes (horizontal)" },
    { id:"hoops",    name:"Hoops" },
    { id:"sash",     name:"Sash" },
    { id:"quarters", name:"Quarters" },
    { id:"unionjack",name:"Union Jack", nat:true },
    { id:"saltire",  name:"Scotland",   nat:true },
    { id:"stgeorge", name:"England",    nat:true }
  ];
  function isNational(id){ for(var i=0;i<PATTERNS.length;i++){ if(PATTERNS[i].id===id) return !!PATTERNS[i].nat; } return false; }
  var PRESET_COLS = ["#e02128","#1b3a8c","#0a7a3f","#f5c518","#101010","#ffffff","#7a1f2b","#00a1e0","#f47a1f","#5b2a86"];

  var _lid = 0; function newId(){ return ++_lid; }
  var S = {
    sizeIdx:0, material:"light", pattern:"halvesV", colA:"#1b3a8c", colB:"#ffffff",
    bgImage:null, bgFile:null, bgImg:null,   // uploaded custom background (dataURL, File, preloaded Image)
    layers:[ { id:newId(), type:"text", text:"YOUR CLUB", font:"anton", color:"#ffffff", size:11, outline:false, outlineColor:"#0b0b0b", outlineW:3, shadow:false, rotate:0, x:0, y:24 } ],
    selId:null, aspect: DATA.sizes[0].aspect || 1.6667
  };
  S.selId = S.layers[0].id;

  /* ---------- pattern drawing (preview + export) ---------- */
  function drawPattern(ctx, w, h, pat, a, b){
    ctx.clearRect(0,0,w,h); var i, mn = Math.min(w,h);
    if(pat === "stgeorge"){ ctx.fillStyle="#fff"; ctx.fillRect(0,0,w,h); ctx.fillStyle="#CE1124"; var t=mn*0.2; ctx.fillRect(0,(h-t)/2,w,t); ctx.fillRect((w-t)/2,0,t,h); return; }
    if(pat === "saltire"){ ctx.fillStyle="#005EB8"; ctx.fillRect(0,0,w,h); ctx.save(); ctx.beginPath(); ctx.rect(0,0,w,h); ctx.clip(); ctx.strokeStyle="#fff"; ctx.lineWidth=mn*0.2; ctx.beginPath(); ctx.moveTo(0,0);ctx.lineTo(w,h);ctx.moveTo(w,0);ctx.lineTo(0,h); ctx.stroke(); ctx.restore(); return; }
    if(pat === "unionjack"){
      ctx.fillStyle="#012169"; ctx.fillRect(0,0,w,h);
      ctx.save(); ctx.beginPath(); ctx.rect(0,0,w,h); ctx.clip();
      ctx.strokeStyle="#fff"; ctx.lineWidth=mn*0.30; ctx.beginPath(); ctx.moveTo(0,0);ctx.lineTo(w,h);ctx.moveTo(w,0);ctx.lineTo(0,h); ctx.stroke();
      ctx.strokeStyle="#C8102E"; ctx.lineWidth=mn*0.12; ctx.beginPath(); ctx.moveTo(0,0);ctx.lineTo(w,h);ctx.moveTo(w,0);ctx.lineTo(0,h); ctx.stroke();
      ctx.restore();
      ctx.fillStyle="#fff"; var wc=mn*0.34; ctx.fillRect((w-wc)/2,0,wc,h); ctx.fillRect(0,(h-wc)/2,w,wc);
      ctx.fillStyle="#C8102E"; var rc=mn*0.20; ctx.fillRect((w-rc)/2,0,rc,h); ctx.fillRect(0,(h-rc)/2,w,rc); return;
    }
    ctx.fillStyle = a; ctx.fillRect(0,0,w,h);
    if(pat === "solid") return;
    if(pat === "halvesV"){ ctx.fillStyle=b; ctx.fillRect(w/2,0,w-w/2,h); return; }
    if(pat === "halvesH"){ ctx.fillStyle=b; ctx.fillRect(0,h/2,w,h-h/2); return; }
    if(pat === "stripesV"){ var n=10, sw=w/n; for(i=0;i<n;i++){ if(i%2){ ctx.fillStyle=b; ctx.fillRect(Math.floor(i*sw),0,Math.ceil(sw)+1,h);} } return; }
    if(pat === "stripesH"){ var m=8, sh=h/m; for(i=0;i<m;i++){ if(i%2){ ctx.fillStyle=b; ctx.fillRect(0,Math.floor(i*sh),w,Math.ceil(sh)+1);} } return; }
    if(pat === "hoops"){ var k=6, hh=h/k; for(i=0;i<k;i++){ if(i%2){ ctx.fillStyle=b; ctx.fillRect(0,Math.floor(i*hh),w,Math.ceil(hh)+1);} } return; }
    if(pat === "quarters"){ ctx.fillStyle=b; ctx.fillRect(w/2,0,w-w/2,h/2); ctx.fillRect(0,h/2,w/2,h-h/2); return; }
    if(pat === "sash"){ var diag=Math.hypot(w,h), bw=diag*0.19; ctx.save(); ctx.translate(w/2,h/2); ctx.rotate(-Math.atan2(h,w)); ctx.fillStyle=b; ctx.fillRect(-diag/2,-bw/2,diag,bw); ctx.restore(); return; }
  }
  function patternUrl(w,h,pat){ var c=document.createElement("canvas"); c.width=w; c.height=h; drawPattern(c.getContext("2d"),w,h,pat,S.colA,S.colB); return c.toDataURL("image/png"); }
  function drawCover(ctx, img, W, H){
    var iw=img.naturalWidth||img.width, ih=img.naturalHeight||img.height; if(!iw||!ih) return;
    var scale=Math.max(W/iw, H/ih), dw=iw*scale, dh=ih*scale;
    ctx.drawImage(img, (W-dw)/2, (H-dh)/2, dw, dh);
  }
  function paintPattern(){
    var pel = $("pattern");
    if(S.bgImage){
      pel.style.backgroundImage = "url('" + S.bgImage + "')";
      pel.style.backgroundSize = "cover";
      pel.style.backgroundPosition = "center";
    } else {
      var w=760, h=Math.max(1, Math.round(760 / S.aspect));
      pel.style.backgroundImage = "url('" + patternUrl(w,h,S.pattern) + "')";
      pel.style.backgroundSize = "100% 100%";
      pel.style.backgroundPosition = "";
    }
    Array.prototype.forEach.call($("patterns").children, function(btn){
      btn.style.backgroundImage = "url('" + patternUrl(120,86,btn.getAttribute("data-pat")) + "')";
      btn.style.backgroundSize = "cover";
    });
  }

  /* ---------- helpers ---------- */
  function fontCss(id){ for(var i=0;i<FONTS.length;i++){ if(FONTS[i].id===id) return FONTS[i].css; } return '"Anton"'; }
  function textShadowFor(L){
    var parts = [];
    if(L.outline){
      var wcqw = (L.outlineW || 3) * 0.1, c = L.outlineColor || "#0b0b0b", dirs = [[1,0],[-1,0],[0,1],[0,-1],[1,1],[1,-1],[-1,1],[-1,-1]];
      dirs.forEach(function(v){ parts.push((v[0]*wcqw) + "cqw " + (v[1]*wcqw) + "cqw 0 " + c); });
    }
    if(L.shadow) parts.push("0 0.6cqw 1.1cqw rgba(0,0,0,.55)");
    return parts.length ? parts.join(",") : "none";
  }
  // Background removal (ported from the award builder) — transparency check, 4-corner agreement, edge flood-fill.
  function removeBackground(imgEl, done){
    var W = imgEl.naturalWidth, H = imgEl.naturalHeight;
    if(!W || !H){ done(null, "unreadable"); return; }
    var scale = Math.min(1, 900 / Math.max(W, H)), w = Math.max(1, Math.round(W*scale)), h = Math.max(1, Math.round(H*scale));
    var c = document.createElement("canvas"); c.width = w; c.height = h; var ctx = c.getContext("2d");
    ctx.drawImage(imgEl, 0, 0, w, h);
    var id, d; try{ id = ctx.getImageData(0,0,w,h); d = id.data; }catch(e){ done(null, "unreadable"); return; }
    var trans = 0; for(var i=3;i<d.length;i+=4){ if(d[i]<250) trans++; }
    if(trans > w*h*0.02){ done(null, "already"); return; }
    function at(x,y){ var o=(y*w+x)*4; return [d[o],d[o+1],d[o+2]]; }
    var corners=[at(0,0),at(w-1,0),at(0,h-1),at(w-1,h-1)], avg=[0,0,0];
    corners.forEach(function(c2){ avg[0]+=c2[0]; avg[1]+=c2[1]; avg[2]+=c2[2]; }); avg=[avg[0]/4,avg[1]/4,avg[2]/4];
    var agree = corners.every(function(c2){ return Math.abs(c2[0]-avg[0])<32 && Math.abs(c2[1]-avg[1])<32 && Math.abs(c2[2]-avg[2])<32; });
    if(!agree){ done(null, "nocorner"); return; }
    var tol=48, visited=new Uint8Array(w*h), stack=[];
    for(var x=0;x<w;x++){ stack.push(x); stack.push((h-1)*w+x); }
    for(var y=0;y<h;y++){ stack.push(y*w); stack.push(y*w+(w-1)); }
    function matches(o){ return Math.abs(d[o]-avg[0])<tol && Math.abs(d[o+1]-avg[1])<tol && Math.abs(d[o+2]-avg[2])<tol; }
    while(stack.length){
      var idx=stack.pop(); if(idx<0||idx>=w*h||visited[idx]) continue; visited[idx]=1; var o=idx*4;
      if(!matches(o)) continue; d[o+3]=0; var px=idx%w;
      if(px>0) stack.push(idx-1); if(px<w-1) stack.push(idx+1); stack.push(idx-w); stack.push(idx+w);
    }
    ctx.putImageData(id, 0, 0); done(c.toDataURL("image/png"), "flood");
  }
  function bgRemoveLayer(L, msgFn){
    var img = new Image();
    img.onload = function(){
      removeBackground(img, function(url, status){
        if(url){ if(!L.origSrc) L.origSrc = L.src; L.src = url; var el = layerEl(L.id); if(el){ var im = el.querySelector("img"); if(im) im.src = url; } msgFn("Background removed ✓", true); }
        else msgFn(status==="already" ? "That image already has a transparent background." : status==="nocorner" ? "Couldn't find a clear background to remove — a PNG with a plain background works best." : "Couldn't process that image.", false);
      });
    };
    img.onerror = function(){ msgFn("Couldn't load that image.", false); };
    img.src = L.src;
  }
  function colorInput(val, fn){ var sw=document.createElement("div"); sw.className="fb-swatch"; sw.style.display="inline-flex"; var c=document.createElement("input"); c.type="color"; c.value=val; c.addEventListener("input", function(){ fn(this.value); }); sw.appendChild(c); return sw; }
  function toggleCtl(title, sub, val, fn){ var t=document.createElement("div"); t.className="fb-toggle"; t.style.marginTop="12px"; t.innerHTML='<div><div class="fb-tg-t"></div><div class="fb-tg-s"></div></div><button class="fb-switch" type="button" aria-pressed="'+String(!!val)+'"></button>'; t.querySelector(".fb-tg-t").textContent=title; t.querySelector(".fb-tg-s").textContent=sub; t.querySelector(".fb-switch").addEventListener("click", function(){ var on=this.getAttribute("aria-pressed")!=="true"; this.setAttribute("aria-pressed",String(on)); fn(on); }); return t; }
  function money(p){ return "£" + (((p||0)/100).toFixed(2)); }
  function layerById(id){ for(var i=0;i<S.layers.length;i++){ if(S.layers[i].id===id) return S.layers[i]; } return null; }
  function layerEl(id){ return $("layers").querySelector('.fb-layer[data-id="'+id+'"]'); }

  /* ---------- render ---------- */
  function render(){
    $("flag").style.setProperty("--fb-aspect", S.aspect);
    root.classList.toggle("fb-natflag", isNational(S.pattern) && !S.bgImage);
    root.classList.toggle("fb-custombg", !!S.bgImage);
    paintPattern();
    updatePrice();
  }
  function renderLayers(){
    var host = $("layers"); host.innerHTML = "";
    S.layers.forEach(function(L){
      var el = document.createElement("div");
      el.className = "fb-layer fb-layer-" + L.type + (L.id===S.selId ? " is-sel" : "");
      el.setAttribute("data-id", L.id);
      el.style.setProperty("--lx", L.x + "cqw");
      el.style.setProperty("--ly", L.y + "cqw");
      el.style.setProperty("--lr", (L.rotate || 0) + "deg");
      if(L.type === "text"){
        el.style.setProperty("--lf", fontCss(L.font));
        el.style.setProperty("--lsz", L.size);
        el.style.setProperty("--lc", L.color);
        el.style.setProperty("--lsh", textShadowFor(L));
        el.textContent = L.text || " ";
      } else {
        el.style.setProperty("--lw", L.size + "cqw");
        var img = document.createElement("img"); img.src = L.src; img.alt = ""; el.appendChild(img);
      }
      host.appendChild(el);
    });
    buildLayerList();
  }
  function updatePrice(){
    var sz = DATA.sizes[S.sizeIdx]; if(!sz) return;
    var v = sz[S.material] || {};
    $("price").textContent = money(v.price);
    $("pricenote").textContent = (S.material==="light" ? "Lightweight (115gsm)" : "Heavyweight (210gsm)") + " · " + sz.label;
    $("sizehd").textContent = sz.label;
    $("varid").value = v.id ? v.id : "";
    $("buy").disabled = !v.id;
    Array.prototype.forEach.call($("sizes").children, function(b){
      var px = b.querySelector(".px2"); if(px) px.textContent = money((DATA.sizes[+b.getAttribute("data-size")][S.material]||{}).price);
    });
    Array.prototype.forEach.call($("materials").children, function(b){
      var px = b.querySelector(".px2"); if(px) px.textContent = money((sz[b.getAttribute("data-mat")]||{}).price);
    });
  }

  /* ---------- layers: list + editor ---------- */
  function buildLayerList(){
    var host = $("layerlist"); host.innerHTML = "";
    S.layers.forEach(function(L){
      var row = document.createElement("div"); row.className = "fb-lrow" + (L.id===S.selId ? " is-sel" : "");
      var lab = L.type === "text" ? (L.text || "Text") : "Crest / image";
      row.innerHTML = '<span class="li">' + (L.type==="text" ? "T" : "🖼") + '</span><span class="ln"></span><button class="lx" type="button" aria-label="Remove">&times;</button>';
      row.querySelector(".ln").textContent = lab;
      row.addEventListener("click", function(e){ if(e.target.closest(".lx")) return; selectLayer(L.id); });
      row.querySelector(".lx").addEventListener("click", function(e){ e.stopPropagation(); deleteLayer(L.id); });
      host.appendChild(row);
    });
  }
  function fieldLb(t){ var l=document.createElement("label"); l.className="fb-lb"; l.textContent=t; return l; }
  function updShadow(L){ var el=layerEl(L.id); if(el) el.style.setProperty("--lsh", textShadowFor(L)); }
  function addRotate(host, L){ host.appendChild(fieldLb("Rotate")); host.appendChild(rangeCtl(-180, 180, L.rotate||0, function(v){ L.rotate=v; var el=layerEl(L.id); if(el) el.style.setProperty("--lr", v+"deg"); })); }
  function buildEditor(){
    var host = $("editor"); host.innerHTML = "";
    var L = layerById(S.selId); if(!L) return;
    if(L.type === "text"){
      var inp = document.createElement("input"); inp.className="fb-input"; inp.type="text"; inp.maxLength=48; inp.value=L.text||""; inp.placeholder="Type your text";
      inp.addEventListener("input", function(){ L.text=this.value; var el=layerEl(L.id); if(el) el.textContent=this.value||" "; buildLayerList(); });
      host.appendChild(fieldLb("Text")); host.appendChild(inp);
      host.appendChild(fieldLb("Font"));
      var frow = document.createElement("div"); frow.className="fb-chips";
      FONTS.forEach(function(f){
        var b=document.createElement("button"); b.type="button"; b.className="fb-chip"; b.textContent=f.name; b.style.fontFamily=f.css+",sans-serif"; b.setAttribute("aria-pressed", String(f.id===L.font));
        b.addEventListener("click", function(){ L.font=f.id; var el=layerEl(L.id); if(el) el.style.setProperty("--lf", fontCss(f.id)); Array.prototype.forEach.call(frow.children,function(x){x.setAttribute("aria-pressed",String(x===b));}); });
        frow.appendChild(b);
      });
      host.appendChild(frow);
      host.appendChild(fieldLb("Colour"));
      host.appendChild(colorInput(L.color, function(v){ L.color=v; var el=layerEl(L.id); if(el) el.style.setProperty("--lc", v); }));
      host.appendChild(fieldLb("Size"));
      host.appendChild(rangeCtl(4, 22, L.size, function(v){ L.size=v; var el=layerEl(L.id); if(el) el.style.setProperty("--lsz", v); }));
      addRotate(host, L);
      host.appendChild(toggleCtl("Drop shadow", "Adds depth so it stands out", L.shadow, function(v){ L.shadow=v; updShadow(L); }));
      host.appendChild(toggleCtl("Outline", "A hard edge around the letters", L.outline, function(v){ L.outline=v; updShadow(L); buildEditor(); }));
      if(L.outline){
        host.appendChild(fieldLb("Outline colour"));
        host.appendChild(colorInput(L.outlineColor || "#0b0b0b", function(v){ L.outlineColor=v; updShadow(L); }));
        host.appendChild(fieldLb("Outline thickness"));
        host.appendChild(rangeCtl(1, 8, L.outlineW || 3, function(v){ L.outlineW=v; updShadow(L); }));
      }
    } else {
      host.appendChild(fieldLb("Crest / image size"));
      host.appendChild(rangeCtl(8, 92, L.size, function(v){ L.size=v; var el=layerEl(L.id); if(el) el.style.setProperty("--lw", v+"cqw"); }));
      addRotate(host, L);
      var bgBtn=document.createElement("button"); bgBtn.type="button"; bgBtn.className="fb-addbtn"; bgBtn.style.cssText="margin-top:14px;border-style:solid;flex:1 1 100%"; bgBtn.textContent="✂ Remove background";
      var undo=document.createElement("button"); undo.type="button"; undo.className="fb-addbtn"; undo.style.cssText="margin-top:8px;border-style:solid;flex:1 1 100%"; undo.textContent="Undo remove"; undo.hidden=!L.origSrc;
      var msg=document.createElement("p"); msg.className="fb-hint";
      bgBtn.addEventListener("click", function(){ bgBtn.disabled=true; bgBtn.textContent="Removing…"; bgRemoveLayer(L, function(m, ok){ bgBtn.disabled=false; bgBtn.textContent="✂ Remove background"; msg.textContent=m; if(ok) undo.hidden=false; }); });
      undo.addEventListener("click", function(){ if(L.origSrc){ L.src=L.origSrc; L.origSrc=null; var el=layerEl(L.id); if(el){ var im=el.querySelector("img"); if(im) im.src=L.src; } undo.hidden=true; msg.textContent="Reverted."; } });
      host.appendChild(bgBtn); host.appendChild(undo); host.appendChild(msg);
    }
    var del=document.createElement("button"); del.type="button"; del.className="fb-addbtn"; del.style.marginTop="14px"; del.style.borderStyle="solid"; del.textContent="🗑 Remove this "+(L.type==="text"?"text":"image");
    del.addEventListener("click", function(){ deleteLayer(L.id); });
    host.appendChild(del);
  }
  function rangeCtl(min, max, val, fn){ var r=document.createElement("input"); r.className="fb-range"; r.type="range"; r.min=min; r.max=max; r.value=val; r.addEventListener("input", function(){ fn(+this.value); }); return r; }

  function selectLayer(id){
    S.selId = id;
    Array.prototype.forEach.call($("layers").children, function(el){ el.classList.toggle("is-sel", +el.getAttribute("data-id")===id); });
    buildLayerList(); buildEditor();
  }
  function addText(){ var L={ id:newId(), type:"text", text:"New text", font:"anton", color:"#ffffff", size:8, outline:false, outlineColor:"#0b0b0b", outlineW:3, shadow:false, rotate:0, x:0, y:0 }; S.layers.push(L); renderLayers(); selectLayer(L.id); }
  function addImage(src, file){ var L={ id:newId(), type:"image", src:src, file:file, size:34, rotate:0, x:0, y:0 }; S.layers.push(L); renderLayers(); selectLayer(L.id); }
  function deleteLayer(id){
    S.layers = S.layers.filter(function(L){ return L.id!==id; });
    if(S.selId===id) S.selId = S.layers.length ? S.layers[S.layers.length-1].id : null;
    renderLayers(); buildEditor();
  }

  /* ---------- drag any layer ---------- */
  (function(){
    var host = $("layers"), flag = $("flag"), drag = null;
    host.addEventListener("pointerdown", function(e){
      var el = e.target.closest(".fb-layer"); if(!el) return;
      var id = +el.getAttribute("data-id"), L = layerById(id); if(!L) return;
      selectLayer(id);
      var r = flag.getBoundingClientRect();
      drag = { px:e.clientX, py:e.clientY, ox:L.x, oy:L.y, w:r.width||600, L:L, el:el };
      root.classList.add("fb-crestdrag");
      try{ el.setPointerCapture(e.pointerId); }catch(_e){}
      e.preventDefault();
    });
    host.addEventListener("pointermove", function(e){
      if(!drag) return;
      var half = 50, halfY = 50 / S.aspect;
      drag.L.x = Math.max(-half, Math.min(half, drag.ox + (e.clientX - drag.px) / drag.w * 100));
      drag.L.y = Math.max(-halfY, Math.min(halfY, drag.oy + (e.clientY - drag.py) / drag.w * 100));
      drag.el.style.setProperty("--lx", drag.L.x + "cqw");
      drag.el.style.setProperty("--ly", drag.L.y + "cqw");
    });
    function end(e){ if(!drag) return; drag=null; root.classList.remove("fb-crestdrag"); }
    host.addEventListener("pointerup", end);
    host.addEventListener("pointercancel", end);
  })();

  /* ---------- build the fixed controls ---------- */
  function setPressed(container, attr, val){ Array.prototype.forEach.call(container.children, function(c){ if(c.getAttribute(attr)!==null) c.setAttribute("aria-pressed", String(c.getAttribute(attr)===val)); }); }
  DATA.sizes.forEach(function(sz, idx){
    var b=document.createElement("button"); b.type="button"; b.className="fb-chip"; b.setAttribute("data-size", idx); b.setAttribute("aria-pressed", String(idx===0));
    b.innerHTML = '<span>'+sz.label+'</span><span class="px2"></span>';
    b.addEventListener("click", function(){ S.sizeIdx=idx; S.aspect=sz.aspect; setPressed($("sizes"),"data-size",String(idx)); render(); });
    $("sizes").appendChild(b);
  });
  Array.prototype.forEach.call($("materials").children, function(btn){ btn.addEventListener("click", function(){ S.material=btn.getAttribute("data-mat"); setPressed($("materials"),"data-mat",S.material); updatePrice(); }); });
  PATTERNS.forEach(function(p){
    var b=document.createElement("button"); b.type="button"; b.className="fb-patbtn"; b.setAttribute("data-pat",p.id); b.setAttribute("aria-pressed", String(p.id===S.pattern)); b.setAttribute("aria-label",p.name); b.title=p.name;
    b.addEventListener("click", function(){ S.pattern=p.id; if(S.bgImage) clearCustomBg(); setPressed($("patterns"),"data-pat",p.id); render(); });
    $("patterns").appendChild(b);
  });
  PRESET_COLS.forEach(function(hex){ var b=document.createElement("button"); b.type="button"; b.style.background=hex; b.title=hex; b.addEventListener("click", function(){ S.colA=hex; $("colA").value=hex; render(); }); $("presetcols").appendChild(b); });
  function onInput(id, fn){ var e=$(id); if(e) e.addEventListener("input", fn); }
  onInput("colA", function(){ S.colA=this.value; render(); });
  onInput("colB", function(){ S.colB=this.value; render(); });
  $("safetoggle").addEventListener("click", function(){ var on=this.getAttribute("aria-pressed")!=="true"; this.setAttribute("aria-pressed",String(on)); root.classList.toggle("fb-showsafe",on); });
  $("addtext").addEventListener("click", addText);
  $("addimage").addEventListener("click", function(){ $("imagefile").click(); });
  $("imagefile").addEventListener("change", function(){
    var f=this.files && this.files[0]; if(!f) return;
    var rd=new FileReader(); rd.onload=function(){ addImage(rd.result, f); }; rd.readAsDataURL(f); this.value="";
  });

  /* ---------- upload-your-own background ---------- */
  function clearCustomBg(){
    S.bgImage=null; S.bgFile=null; S.bgImg=null;
    var chip=$("bgchip"); if(chip) chip.classList.add("fb-hidden");
    setPressed($("patterns"),"data-pat",S.pattern);
  }
  function setCustomBg(dataUrl, file){
    S.bgImage=dataUrl; S.bgFile=file;
    var img=new Image(); img.onload=function(){ S.bgImg=img; render(); }; img.src=dataUrl;
    var chip=$("bgchip"); if(chip) chip.classList.remove("fb-hidden");
    var th=$("bgthumb"); if(th) th.src=dataUrl;
    var nm=$("bgname"); if(nm) nm.textContent=(file&&file.name)?file.name:"Custom background";
    setPressed($("patterns"),"data-pat","__none__");   // no pattern selected while custom bg is on
    render();
  }
  $("bgfile").addEventListener("change", function(){
    var f=this.files && this.files[0]; if(!f) return;
    var rd=new FileReader(); rd.onload=function(){ setCustomBg(rd.result, f); }; rd.readAsDataURL(f); this.value="";
  });
  $("bgremove").addEventListener("click", function(){ clearCustomBg(); render(); });

  /* ---------- export + add to cart ---------- */
  function sanitize(s){ return String(s||"flag").replace(/[^a-z0-9]+/gi,"-").replace(/^-+|-+$/g,"").toLowerCase() || "flag"; }
  function firstText(){ for(var i=0;i<S.layers.length;i++){ if(S.layers[i].type==="text" && S.layers[i].text) return S.layers[i].text; } return "flag"; }
  function firstImageFile(){ for(var i=0;i<S.layers.length;i++){ if(S.layers[i].type==="image" && S.layers[i].file) return S.layers[i].file; } return null; }
  function specText(){
    var sz = DATA.sizes[S.sizeIdx]||{};
    var pat=(function(){ for(var i=0;i<PATTERNS.length;i++){ if(PATTERNS[i].id===S.pattern) return PATTERNS[i].name; } return S.pattern; })();
    var texts = S.layers.filter(function(L){return L.type==="text" && L.text;}).map(function(L){return L.text;});
    var imgs = S.layers.filter(function(L){return L.type==="image";}).length;
    var bg = S.bgImage ? "Custom uploaded image" : (pat + (isNational(S.pattern)?"":(" ("+S.colA+" / "+S.colB+")")));
    return ["Size: "+(sz.label||""), "Material: "+(S.material==="light"?"Lightweight (115gsm)":"Heavyweight (210gsm)"),
      "Background: "+bg,
      "Text: "+(texts.join(" | ")||"none"), "Images: "+imgs].join(" · ");
  }
  function attach(id, blob, name, type){ try{ var dt=new DataTransfer(); dt.items.add(new File([blob], name, {type:type})); $(id).files=dt.files; return true; }catch(e){ return false; } }
  function attachExisting(id, file){ try{ var dt=new DataTransfer(); dt.items.add(file); $(id).files=dt.files; return true; }catch(e){ return false; } }
  function composeFlag(cb){
    var ready = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
    ready.then(function(){
      if(typeof html2canvas !== "function") return cb(null);
      var flag=$("flag"), r=flag.getBoundingClientRect(), fw=r.width||600;
      var EW=3500, EH=Math.max(1, Math.round(EW / S.aspect));
      var pc=document.createElement("canvas"); pc.width=EW; pc.height=EH;
      var pctx=pc.getContext("2d");
      function paintOverlay(){
        var pat=$("pattern"), safe=flag.querySelector(".fb-safe"), wave=flag.querySelector(".fb-wave");
        var pv=pat.style.visibility, sv=safe.style.display, wv=wave.style.display, pbg=flag.style.background;
        pat.style.visibility="hidden"; safe.style.display="none"; wave.style.display="none";
        flag.style.background="transparent";           // so the flag's #222 fallback doesn't cover the drawn background
        root.classList.add("fb-exporting");
        function restore(){ pat.style.visibility=pv; safe.style.display=sv; wave.style.display=wv; flag.style.background=pbg; root.classList.remove("fb-exporting"); }
        html2canvas(flag, { backgroundColor:null, scale:EW/fw, useCORS:true, logging:false }).then(function(layer){
          restore(); pctx.drawImage(layer, 0, 0, EW, EH); cb(pc);
        }).catch(function(){ restore(); cb(null); });
      }
      if(S.bgImage){
        var bi=S.bgImg;
        if(bi && bi.complete && bi.naturalWidth){ drawCover(pctx, bi, EW, EH); paintOverlay(); }
        else { var im=new Image(); im.onload=function(){ drawCover(pctx, im, EW, EH); paintOverlay(); }; im.onerror=paintOverlay; im.src=S.bgImage; }
      } else {
        drawPattern(pctx, EW, EH, S.pattern, S.colA, S.colB); paintOverlay();
      }
    });
  }
  function showLoading(){ var l=$("loading"); if(!l) return; l.hidden=false; var f=$("barfill"); if(f){ f.style.transition="none"; f.style.width="0%"; void f.offsetWidth; f.style.transition="width 2.6s cubic-bezier(.2,.8,.25,1)"; f.style.width="90%"; } }
  function finishLoading(cb){ var f=$("barfill"); if(f){ f.style.transition="width .35s ease"; f.style.width="100%"; } setTimeout(cb, 400); }
  function hideLoading(){ var l=$("loading"); if(l) l.hidden=true; }
  var form = $("form");
  form.addEventListener("submit", function(e){
    if(form.__ready) return;
    e.preventDefault();
    if(!$("varid").value){ alert("Please choose a size and material first."); return; }
    showLoading();
    composeFlag(function(canvas){
      if(!canvas || !canvas.toBlob){ hideLoading(); alert("Sorry — couldn't build the flag just now. Please try again."); return; }
      canvas.toBlob(function(blob){
        if(blob) attach("p-design", blob, sanitize(firstText())+"-flag.jpg", "image/jpeg");
        var cf=firstImageFile(); if(cf) attachExisting("p-crest", cf);
        if(S.bgFile) attachExisting("p-bg", S.bgFile);
        $("p-size").value = (DATA.sizes[S.sizeIdx]||{}).label || "";
        $("p-material").value = S.material==="light" ? "Lightweight (115gsm)" : "Heavyweight (210gsm)";
        $("p-club").value = firstText();
        $("p-spec").value = specText();
        form.__ready = true;
        finishLoading(function(){ form.submit(); });
      }, "image/jpeg", 0.92);
    });
  });

  render(); renderLayers(); buildEditor();
})();
